import { render } from "./BackToTop.vue?vue&type=template&id=6aafa912&scoped=true&ts=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"

import "./BackToTop.vue?vue&type=style&index=0&id=6aafa912&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aafa912"]])

export default __exports__